import React from 'react'
import { useParams } from 'react-router-dom'
import PermissionDetails from './PermissionDetails'

const PermissionDetailsWrapper = (props) => {
    const params = useParams()
    return <PermissionDetails {...props} params={params} />
}

export default PermissionDetailsWrapper
